import {createFileRoute} from '@tanstack/react-router';

import Logout from '@/shared/views/user/Logout';

export const Route = createFileRoute('/(shared)/logout')({
  component: Logout
});
